// extracted by mini-css-extract-plugin
export default {"fontWeight":"bold","fontSize":"14","fontColor":"#002942","firstChartColor":"#68a62b","secondChartColor":"#002942"};